import React, { useEffect, useState, useLayoutEffect } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import img from "../../Assets/undraw_privacy_protection_nlwy@2x.png";
import "./Privacy.css";
import SubNav from "../../Layout/SubNav";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";

const Privacy = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [data, setData] = useState();
  useEffect(async () => {
    const pp = await axios.get(
      "https://staging-cms-main.ipurvey.com/privacy-policy"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([pp.data, layout.data]);
  }, []);
  if (data) {
    return (
      <div className="terms_and_cond_container">
        <SubNav head="Privacy policy" />
        <div className="terms_and_cond_main_div privacy_md">
          <div className="terms_boxex_div privacy_scroll_div">
            <div className="terms_one_box_div">
              <ReactMarkdown>{data[0]?.paragraph_left?.content}</ReactMarkdown>
            </div>
            <div className="terms_box_two_scroll">
              <ReactMarkdown>{data[0]?.paragraph_right?.content}</ReactMarkdown>
            </div>
          </div>
          <div className="terms_two_div">
            <div className="terms_two_box_para_div privacy_img_div">
              <div>
                <img src={img} alt="" />
              </div>
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </div>
    );
  } else return <Loader />;
};

export default Privacy;
